import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout';

// Pages
import Home from './pages/Home';
import Accommodations from './pages/Accommodations';
import RentCamp from './pages/RentCamp';
import About from './pages/About';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Forbidden from './pages/Forbidden';
import NotFound from './pages/NotFound';

function App() {
  return (
    <HelmetProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/feriehuse" element={<Accommodations />} />
          <Route path="/lej-campen" element={<RentCamp />} />
          <Route path="/om-campen" element={<About />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/forretningsbetingelser" element={<Terms />} />
          <Route path="/privatlivspolitik" element={<Privacy />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </HelmetProvider>
  );
}

export default App;
